import { Component, Input } from '@angular/core';
import { EIconPath } from '../../../../../../../shared/enums/icons.enum';
import { TActivityChange } from '../../activity-change.model';

@Component({
    selector: 'pp-dashlet-activity-rich-text',
    templateUrl: './dashlet-activity-rich-text.component.html',
    styleUrls: ['../../dashlet-activity.component.scss'],
    standalone: false
})
export class DashletActivityRichTextComponent {
  @Input() ppChange: TActivityChange<string>;

  EIconPath = EIconPath;

  constructor() {}
}
